import { Model } from '@/models/Model';
import { User } from '@/models/User';

export class UserFile extends Model {
  protected $name: string = 'UserFile';
  protected $endpoint: string = '/users/{id}/relationships/files';
  protected $fillable: string[] = ['file', 'name', 'meta'];

  public id?: string;
  public file?: File;
  public name?: string;
  public mime_type?: string;
  public meta?: Meta;

  public user(user: User | string) {
    if (typeof user !== 'string') {
      user = user.id || '';
    }
    this.$endpoint = `/users/${user}/relationships/files`;

    return this;
  }

  public setIdAttribute(id: string) {
    this.$endpoint = `/users/${this.user}/relationships/files`;

    return id;
  }

  deleteUserFile(userId: string, id: string) {
    const url = `/users/${userId}/relationships/files/${id}`;
    return this.request('delete', url);
  }

  public resolvePrimaryKey(): string {
    return '';
  }
}

interface Meta {
  subject: string;
}
